import qs from 'qs'

export const queryPermanentWorksPage = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault,
        blocks: {
          ...queryFragmentBlocks?.blocks
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `permanent-works-page?${query}`
}
